var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import Icon from '../icon/index';
class InputNumber extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = (type) => {
            const { min, max, step, disabled } = this.props;
            if (disabled)
                return;
            const nowValue = this.state.value;
            let nextVal = nowValue;
            if (type === 'down') {
                nextVal = nowValue - step <= min ? min : nowValue - step,
                    this.setState({
                        value: nextVal,
                    });
            }
            else if (type === 'up') {
                nextVal = !!max && nowValue + step >= max ? max : nowValue + step;
                this.setState({
                    value: nextVal,
                });
            }
            const { onChange } = this.props;
            onChange && onChange(nextVal); // valid number or invalid string
        };
        this.onFocus = (e) => {
            const { onFocus } = this.props;
            onFocus && onFocus(e);
        };
        this.onBlur = (e) => {
            const { min, max, onBlur, onChange } = this.props;
            let value = parseInt(e.target.value);
            value = isNaN(value) || value <= min ? min : value;
            value = !!max && value >= max ? max : value;
            if (this.state.value !== value) {
                this.setState({
                    value,
                });
                onChange && onChange(value);
            }
            onBlur && onBlur(e);
        };
        // '1.' '1x' 'xx' '' => are not complete numbers
        this.isNotCompleteNumber = (num) => {
            return (isNaN(num) ||
                num === '' ||
                num === null ||
                (num && num.toString().indexOf('.') === num.toString().length - 1));
        };
        this.state = {
            value: props.value || props.defaultValue,
        };
        this.handleChange = this.handleChange.bind(this);
    }
    static getDerivedStateFromProps(nextProps) {
        if (nextProps.value !== undefined) {
            return {
                value: nextProps.value,
            };
        }
        return null;
    }
    handleChange(event) {
        const { disabled, onChange } = this.props;
        if (disabled)
            return;
        let value = parseInt(event.target.value);
        if (isNaN(value)) {
            value = '';
        }
        this.setState({ value });
        onChange && onChange(value); // valid number or invalid string
    }
    render() {
        const _a = this.props, { style, className, max, min, disabled, size, pointerEvents } = _a, restProps = __rest(_a, ["style", "className", "max", "min", "disabled", "size", "pointerEvents"]);
        const { value } = this.state;
        const numCls = classnames('cfm_number_waper', `cfm_number_${size}`, className);
        const reduceBtnCls = classnames('cfm_number_btn', 'cfm_number_reduce', {
            'cfm_number_btn_disabled': disabled || min >= value,
        });
        const addBtnCls = classnames('cfm_number_btn', 'cfm_number_add', {
            'cfm_number_btn_disabled': disabled || max <= value,
        });
        const inputCls = classnames('cfm_number_input', {
            'cfm_no_pointer': !pointerEvents,
        });
        const iconSize = size === 'sm' ? 'sm' : 'md';
        return (<div className={numCls} style={style}>
        <button onClick={() => this.handleClick('down')} className={reduceBtnCls}>
          <Icon size={iconSize} type='reduce'/>
        </button>
        <input {...restProps} className={inputCls} onChange={this.handleChange} onBlur={this.onBlur} value={value} defaultValue={undefined} max={max} min={min} disabled={disabled} autoComplete="off" pattern={'[0-9]*'}/>
        <button onClick={() => this.handleClick('up')} className={addBtnCls}>
          <Icon size={iconSize} type='add'/>
        </button>
      </div>);
    }
}
InputNumber.defaultProps = {
    min: 0,
    max: 9999999999,
    step: 1,
    defaultValue: 0,
    style: {},
    disabled: false,
    size: 'md',
    pointerEvents: true,
};
InputNumber.inputNumberRef = null;
export default InputNumber;



// WEBPACK FOOTER //
// ./components/input-number/index.tsx